import { useWebhookFieldCreateIntegrationWebhookFieldCreatePostMutation } from '@shared/api';
import type { WebhookIntegrationCreateFieldFormValues } from '../lib/types';

export const useCreateIntegrationField = () => {
  const [createIntegrationFieldMutation, { isLoading: isCreateIntegrationFieldLoading }] =
    useWebhookFieldCreateIntegrationWebhookFieldCreatePostMutation();

  const createIntegrationField = async (
    integrationId: number,
    values: WebhookIntegrationCreateFieldFormValues,
  ) => {
    try {
      await createIntegrationFieldMutation({
        webhookIntegrationId: integrationId,
        webhookIntegrationFieldCreate: {
          location: values.location,
          parameter_name: values.parameterName,
          agent_field_id: values.agentFieldId,
          value: values.value,
        },
      }).unwrap();

      return true;
    } catch {}

    return false;
  };

  return {
    createIntegrationField,
    isCreateIntegrationFieldLoading,
  };
};
